import React from 'react';

const MembersTable = ({ member, selectMember, isSelected }) => {
  const {
    endpoint,
    membername,
    paused,
    penalty,
    queueName,
    queue_name,
    ringinuse,
    stateinterface,
    wrapuptime,
    uniqueid,
    memberorder
  } = member;

  const displayQueueName = (queueName !== null && queueName !== undefined && queueName !== '')
    ? String(queueName).trim()
    : (queue_name !== null && queue_name !== undefined && queue_name !== '')
      ? String(queue_name).trim()
      : '-';

  return (
    <tr>
      <td className="checkbox-cell"><input name="uniqueid" type="checkbox" checked={Boolean(isSelected)} onChange={() => selectMember(uniqueid)}></input></td>
      <td>{endpoint || '-'}</td>
      <td>{membername || '-'}</td>
      <td>{displayQueueName}</td>
      <td>{paused?'Sim':'Não'}</td>
      <td>{penalty !== null && penalty !== undefined ? penalty : '-'}</td>
      <td>{memberorder !== null && memberorder !== undefined ? memberorder : '-'}</td>
      <td>{ringinuse || '-'}</td>
      <td>{stateinterface || '-'}</td>
      <td>{wrapuptime !== null && wrapuptime !== undefined ? wrapuptime : '-'}</td>
    </tr>
  );
};

export default MembersTable;
